import React from 'react';
import { FormContext } from 'react-components-form';

class CheckboxGroup extends React.Component {
    static contextType = FormContext;

    constructor() {
        super();
        this.getErrors = this.getErrors.bind(this);
    }

    getErrors() {
        const errors = this.context.getAllValidationErrors();
        const checkboxes = this.props.children;
        const result = [];

        if (Object.keys(errors).length > 0) {
            for (let error of Object.keys(errors)) {
                for (let checkbox of checkboxes) {
                    if (error === checkbox.props.name) {
                        result.push(
                            <div key={error} className="check-group__notice">{errors[error]}</div>
                        );
                    }
                }
            }
        }

        return (result)
    }

    render() {
        return (
            <div className={this.getErrors().length ? 'mb-3 is-error' : 'mb-3'}>
                <div className="check-group__text">Roles</div>
                <div className="check-group__control">
                    {this.props.children}
                </div>
                {(this.props.required && this.getErrors().length === 0) ? (
                    <div className="check-group__notice">Selle välja täitmine on kohustuslik.</div>
                ) : (
                    <div/>
                )}

                {this.getErrors()}
            </div>
        )
    }
}

export default CheckboxGroup;
